import React, { useEffect, useState } from "react";
import Banner from "../../Components/Banner";
import Nav from "../../Components/Nav";
import './styles.scss'
import '../../Components/Reset/body.scss'
import SobreMim from "../../Components/SobreMim";
import Projetos from "../../Components/Projetos";
import Habilidades from "../../Components/Habilidades";
import Footer from "../../Components/Footer";
import Layout from "../../Components/Layout";

const Home = () => {

  return (
      <Layout>
        <div id="Banner">
          <Banner />
        </div>
        <div className="Bio" id="SobreMim">
          <SobreMim />
        </div>
        <div id="Projetos">
          <Projetos />
        </div>
        <div id="Habilidades">
          <Habilidades />
        </div>
        <div id="Contato">
        </div>
      </Layout>
  );
}
export default Home;